import Slider from 'root/src/client/web/base/Slider';
import identity from 'ramda/src/identity';
import { useRedeemedRewardsModal } from 'root/src/client/web/giveaway/features/RedeemedRewardsModal/hooks/useRedeemedRewardsModal';
import { RedeemedReward } from 'root/src/client/web/giveaway/features/RedeemedRewardsModal/RedeemedReward';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
const RedeemedRewardsModal = (props) => {
    const { rewards } = useRedeemedRewardsModal(props);
    return (<ModalLayout>
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
			{/* @ts-ignore */}
			<Slider containerClassName="gap-8 flex" arrows renderItems={() => identity} renderSliderItem={() => identity} showItems={1} infinite sliderItemsStyle="gap-4 flex justify-center">
				{rewards.map((reward, idx) => (<RedeemedReward key={reward.id} reward={reward} total={rewards.length} index={idx + 1}/>))}
			</Slider>
		</ModalLayout>);
};
export default RedeemedRewardsModal;
